import localforage from 'localforage'

localforage.config({
  driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB, localforage.WEBSQL],
  name: 'rooommates',
  storeName: 'rooommates'
})

export { localforage }
